module.exports = __webpack_public_path__ + "img/login_head.bfcfbad7.png";